import React from 'react';

import { ta, adminLocale } from '../../i18n/adminT';
export default function EventContactDetailModal({ contact, onClose }) {
  const createdAt = new Date(contact.created_at);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-card business-card-modal" onClick={(e) => e.stopPropagation()}>
        <div className="business-card">
          <div className="business-card-accent" />
          <div className="business-card-body">
            <div className="business-card-name">{contact.nome} {contact.cognome}</div>
            {(contact.ruolo || contact.azienda) && (
              <div className="business-card-role">
                {contact.ruolo}{contact.ruolo && contact.azienda ? ' · ' : ''}{contact.azienda}
              </div>
            )}

            <div className="business-card-contacts">
              <div className="business-card-contact-row">
                <span className="business-card-icon">✉</span>
                <span>{contact.email}</span>
              </div>
              {contact.telefono && (
                <div className="business-card-contact-row">
                  <span className="business-card-icon">☎</span>
                  <span>{contact.telefono}</span>
                </div>
              )}
            </div>

            {contact.evento && (
              <div className="business-card-tag">{contact.evento}</div>
            )}

            {contact.note && (
              <div className="business-card-note">
                <span className="contract-field-label">{ta('Note')}</span>
                <p>{contact.note}</p>
              </div>
            )}

            <div className="business-card-meta">
              <span>{contact.privacy_accepted ? ta('Privacy accettata') : ta('Privacy non accettata')}</span>
              <span>{contact.device_label || ta('Dispositivo non rilevato')}</span>
              <span>{createdAt.toLocaleString(adminLocale())}</span>
            </div>
          </div>
        </div>

        <div className="btn-row" style={{ marginTop: 18 }}>
          <button type="button" className="btn btn-primary" onClick={onClose}>{ta('Chiudi')}</button>
        </div>
      </div>
    </div>
  );
}
